import React from "react";
import { Link } from "react-router-dom";
import { Gamepad2, ArrowLeft, GraduationCap } from "lucide-react";
import { MatchGame, ControlRoom, NegotiationGame } from "../components/CourseGames";
import DispatchSim from "../components/DispatchSim";

const Games = () => {
  return (
    <div className="training" data-testid="games-page">
      <header className="tr-hero">
        <div className="container">
          <Link to="/" className="tr-back" data-testid="games-back-link"><ArrowLeft size={14} /> Back to site</Link>
          <span className="eyebrow"><Gamepad2 size={14} /> Free Dispatch Arcade</span>
          <h1>Play the Dispatch Games — Free</h1>
          <p>Get a taste of the Flying Fleet Dispatch Masterclass. Match equipment to freight, make the right calls in the Control Room, negotiate a broker up, and run a full dispatch day. No sign-up required.</p>
          <Link to="/training" className="btn btn-primary" data-testid="games-enroll-cta"><GraduationCap size={16} /> Unlock the full 10-module course</Link>
        </div>
      </header>

      <section className="container tr-game-wrap"><MatchGame /></section>
      <section className="container tr-game-wrap"><ControlRoom /></section>
      <section className="container tr-game-wrap"><NegotiationGame /></section>
      <section className="container tr-game-wrap"><DispatchSim /></section>

      <section className="container" style={{ textAlign: "center", padding: "20px 24px 60px" }}>
        <p className="tr-sub" style={{ marginBottom: 16 }}>Enjoyed the games? The full masterclass has 10 modules, quizzes, a glossary, and a completion certificate.</p>
        <Link to="/training" className="btn btn-primary" data-testid="games-enroll-cta-bottom"><GraduationCap size={16} /> Explore the course</Link>
      </section>
    </div>
  );
};

export default Games;
